import styled from "styled-components"

const Taxo = styled.p`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`

export { Taxo }
